import React from "react";
import { GraduationCap } from "lucide-react";
import { partners } from "../mock";

export default function UniversityPartners() {
  return (
    <section id="partners" className="relative px-4 md:px-8 pb-20 md:pb-28">
      <div className="mx-auto max-w-[1400px] rounded-[32px] bg-white border border-[#eee6f7] shadow-sm p-8 md:p-12 lg:p-14">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_auto] gap-10 items-center">
          <div>
            <div className="inline-flex items-center gap-2 bg-[#3dc9b3]/15 text-[#1a2464] font-semibold text-xs px-4 py-1.5 rounded-full mb-4">
              <GraduationCap className="w-3.5 h-3.5 text-[#3dc9b3]" />
              University Partners
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2464] tracking-tight leading-tight max-w-2xl">
              Training the next generation of doctors
            </h2>
            <p className="text-[#4a4a63] leading-relaxed mt-4 max-w-2xl">
              We are proud partners with some of the leading universities of the country in training and educating medical students. Our practice has helped many students with excellent mentorship and real-world experience.
            </p>
          </div>

          <div className="flex flex-wrap items-center justify-start lg:justify-end gap-4 md:gap-6">
            {partners.map((p) => (
              <div
                key={p.name}
                data-testid={`partner-${p.name.toLowerCase().replace(/\s+/g, "-")}`}
                className="flex items-center gap-3 bg-[#f7f5fb] border border-[#eee6f7] rounded-2xl pl-2 pr-5 py-2 hover:shadow-md transition-shadow"
              >
                {p.wordmark ? (
                  <img
                    src={p.logo}
                    alt={`${p.name} logo`}
                    className="h-12 md:h-14 w-auto object-contain px-2"
                    loading="lazy"
                  />
                ) : (
                  <>
                    <img
                      src={p.logo}
                      alt={`${p.name} logo`}
                      className="w-12 h-12 md:w-14 md:h-14 rounded-xl object-cover shrink-0 bg-white"
                      loading="lazy"
                    />
                    <span className="text-[#1a2464] font-semibold text-sm md:text-[15px] leading-tight max-w-[120px]">{p.name}</span>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
